import React from "react";
import ShipTransport from "./ShipTransport";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope3Layout from "../../../../Layout/Scope3Layout";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import GroupAdminSidebar from "../../../../Layout/GroupAdminSidebar";
import { useUser } from "../../../../context/AuthContext";
const Ship = () => {
   const{user}=useUser();
  return (
    <MainDashboardLayout sidebar={user?.groupManager?<GroupAdminSidebar/>:<Scope3Layout />}>
      <Unauthorized requiredModule="Environment | Scope 3 | Transportation distribution">
        <ShipTransport />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Ship;
